import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.monitoring.user.statistic');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Chart } from 'chart.js/auto';
import moment from 'moment';

@Component({
    selector: 'wiz-portal-monitoring-user-statistic',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.monitoring.user.statistic/view.scss */
/* src/app/portal.monitoring.user.statistic/view.scss: no such file or directory */`],
})
export class PortalMonitoringUserStatisticComponent implements OnInit, OnDestroy {

    public machines: any[] = [];
    public list: any[] = [];
    public page: number = 1;
    public lastPage: number = 0;
    public loading: boolean = false;
    public chartLoading: boolean = false;

    public map: any = {
        grade: '왕란,특란,대란,중란,소란,경란,파란,혈란,오란,등외'.split(',')
    };

    public search: any = {
        machine_id: '',
        line: '',
        house_no: '',
        grade: '',
        start: '',
        end: '',
    };

    private charts: Record<string, Chart> = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const machineRes = await wiz.call('machines');
        this.machines = machineRes?.data || [];
        await this.searchSubmit();
        await this.service.render();
    }

    ngOnDestroy() {
        for (const key of Object.keys(this.charts)) {
            this.charts[key].destroy();
        }
        this.charts = {};
    }

    public normalizeParams() {
        const params: any = { ...this.search, page: this.page };
        if (params.start) params.start = moment(params.start).format('YYYY-MM-DD');
        if (params.end) params.end = moment(params.end).format('YYYY-MM-DD');
        Object.keys(params).forEach(k => {
            if (params[k] == null || params[k] === '') delete params[k];
        });
        return params;
    }

    public async searchSubmit() {
        this.page = 1;
        await Promise.all([this.load(), this.statistic()]);
    }

    public async load(page?: number) {
        if (page) this.page = page;
        this.loading = true;
        await this.service.render();
        try {
            const params = this.normalizeParams();
            const res = await wiz.call('search', params);
            if (res.code === 200) {
                this.list = res.data.list || [];
                this.lastPage = res.data.lastpage || 0;
            } else {
                this.list = [];
                this.lastPage = 0;
            }
        } catch (e) {
            this.list = [];
            this.lastPage = 0;
        }
        this.loading = false;
        await this.service.render();
    }

    public onPageChange = async (page: number) => {
        this.page = page;
        await this.load();
    }

    public async statistic() {
        this.chartLoading = true;
        await this.service.render();

        const params: any = {};
        if (this.search.start) params.start = moment(this.search.start).format('YYYY-MM-DD');
        if (this.search.end) params.end = moment(this.search.end).format('YYYY-MM-DD');
        if (this.search.machine_id) params.machine_id = this.search.machine_id;
        if (this.search.line) params.line = this.search.line;
        if (this.search.house_no) params.house_no = this.search.house_no;
        if (this.search.grade && this.search.grade !== 'split') params.grade = this.search.grade;

        const res = await wiz.call('statistic', params);

        if (!res || res.code !== 200) {
            this.chartLoading = false;
            await this.service.render();
            return;
        }

        const dates: string[] = [];
        const quantity: number[] = [];
        const weight: number[] = [];
        const plate: number[] = [];

        for (const item of res.data) {
            dates.push(item.date.substring(0, 10));
            quantity.push(item.quantity);
            weight.push(item.quantity ? (item.weight * 1000) / item.quantity : 0);
            plate.push(item.plate);
        }

        this.drawBarChart('quantityChart', '생산수량', dates, quantity);
        this.drawBarChart('weightChart', '평균중량', dates, weight);
        this.drawBarChart('plateChart', '판수', dates, plate);

        this.chartLoading = false;
        await this.service.render();
    }

    private drawBarChart(id: string, title: string, labels: string[], data: number[]) {
        const canvas = document.getElementById(id) as HTMLCanvasElement;
        if (!canvas) return;

        if (this.charts[id]) this.charts[id].destroy();

        const validData = data.filter(v => v != null && v > 0);
        const minVal = validData.length > 0 ? Math.min(...validData) : 0;
        const maxVal = validData.length > 0 ? Math.max(...validData) : 0;
        const range = maxVal - minVal;
        const suggestedMin = range > 0 && minVal > 0 ? Math.max(0, Math.floor(minVal - range * 0.3)) : 0;

        this.charts[id] = new Chart(canvas.getContext('2d')!, {
            type: 'bar',
            data: {
                labels,
                datasets: [{
                    label: title,
                    data,
                    backgroundColor: '#1ba9e9'
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: { ticks: { autoSkip: false } },
                    y: {
                        beginAtZero: suggestedMin === 0,
                        suggestedMin: suggestedMin,
                        ticks: {
                            maxTicksLimit: 8
                        }
                    }
                }
            }
        });
    }
}

export default PortalMonitoringUserStatisticComponent;